import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, SxProps, Tooltip, Typography } from '@mui/material'

interface InfoHintProps {
  /** Nadpis tooltipu (např. nazev vzorce). */
  title?: string
  /** Radky vysvetleni — kazdy se vykresli jako odrazka. */
  lines: string[]
  sx?: SxProps
}

/**
 * Male "i" s vysvetlenim vypoctu/pravidel na hover (F9 — kontrola procesu Vaskem).
 * Pouziva se vsude, kde se neco pocita nebo plati netrivialni pravidlo.
 */
export function InfoHint({ title, lines, sx }: InfoHintProps) {
  return (
    <Tooltip
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={8000}
      componentsProps={{ tooltip: { sx: { maxWidth: 460 } } }}
      title={
        <Box sx={{ p: 0.5 }}>
          {title && (
            <Typography variant="subtitle2" sx={{ mb: 0.5, fontSize: '0.8rem' }}>
              {title}
            </Typography>
          )}
          {lines.map((line, index) => (
            <Typography key={index} variant="body2" sx={{ fontSize: '0.75rem', mb: 0.25, lineHeight: 1.45 }}>
              • {line}
            </Typography>
          ))}
        </Box>
      }
    >
      <InfoOutlinedIcon
        sx={{
          fontSize: 17,
          verticalAlign: 'text-bottom',
          cursor: 'help',
          opacity: 0.7,
          '&:hover': { opacity: 1 },
          ...sx,
        }}
      />
    </Tooltip>
  )
}
